import { useEffect } from "react";
import {HubConnectionBuilder, LogLevel} from '@microsoft/signalr';
import { getAuthAccessToken } from '../../config/auth.config';
import { logger } from "../common/logger";
import { getLoggingSettings } from "../../config/logging.config";

export function useSignalR<T>(props: {
    endPointUrl: string;
    endPointHub: string;
    endPointGroupName: string;
    onSignalResponse(returnObject: T): void;
}) {

    let loggingSettings = getLoggingSettings();
    useEffect(() => {
        let logLevel = loggingSettings.loggingEnabled? LogLevel.Trace:LogLevel.Debug;
        const connection = new HubConnectionBuilder()
            .withUrl(`${props.endPointUrl}hub`, {
                accessTokenFactory: getAuthAccessToken
            })
            .withAutomaticReconnect()
            .configureLogging(logLevel)
            .build();

        connection.on(props.endPointHub, (newObject: T) => {
            props.onSignalResponse(newObject);
        });

        connection.start().then(() => {
            logger.log('Start connecting to ',props.endPointGroupName);
            return connection.invoke('AddToGroup', props.endPointGroupName);
        }).catch(err=>{
            logger.log('Connection failed ', err);
            setTimeout(() => connection.start(), 5000)
        });

        return () => {
            if (connection.state==="Connected") {
                connection.invoke('RemoveFromGroup', props.endPointGroupName).then(() => {
                    return connection.stop();
                });    
            }
        };
    }, []);
}